// import $ from 'jquery';
import moment from 'moment';
import axios from '@/plugins/axios';
import ContactService from '@/services/contact.service';
import { isEqual, cloneDeep, differenceBy } from 'lodash';
import Vue from 'vue';

const webApi = axios();

const contact = {
  props: ['id'],
  directives: {
    zip: {
      update(el) {
        // el.value = el.value.replace(/[-a-zA-Z]/g, ''); // Letters and capital letter, and special character: -
        if (!el.value) '';
        el.value = el.value.replace(/\D/g, '');
        el.value = el.value.replace(/(\d{5})(\d)/, '$1-$2');
      },
    },
  },
  data() {
    return {
      customFieldsToBeAdded: [],
      customFieldIdToEdit: {},
      editSelectedCustomField: false,
      editSelectedCustomFieldValue: '',
      existCustomField: false,
      isDifferent: false,
      customFieldAdd: false,
      editingContact: false,
      formContact: null,
      selectedCustomFieldId: '',
      selectedCustomFieldName: '',
      selectedCustomFieldNewValue: '',
      isLoading: false,
      savingContact: false,
      // currentContact: null,
      visible: false,
      detailedContact: null,
      originalContact: null,
      groupList: [],
      customFields: [],
      currentCustomFields: [],
      formatDate: null,
      genders: [
        {
          text: 'Feminino',
          value: 'female',
        },
        {
          text: 'Masculino',
          value: 'male',
        },
        {
          text: 'Prefiro não dizer',
          value: 'notsay',
        },
      ],
    };
  },
  mounted() {
    console.log('Contact mixin mounted');
    this.getGroupList();
    this.fetchCustomFields();
    // this.$root.$on('show.modal', this.showHandler);
    // this.removeBackdrop();
  },
  // destroy() {
  //   this.removeBackdrop();
  // },
  watch: {
    customFieldsToBeAdded: {
      handler(val, oldVal) {
        // console.debug('TESTE: ', val, '\nthis.customFields value: ', this.customFields);
        if (this.customFieldsToBeAdded) {
          this.isDifferent = !isEqual(
            this.mapEmptyValueToNull(this.customFieldsToBeAdded),
            this.mapEmptyValueToNull(this.customFields),
          );
        }
      },
      deep: true,
    },
    formContact: {
      handler(val, oldVal) {
        // console.log('Tst Item Changed: ', val, '\nOld value: ', oldVal);
        if (this.formContact) {
          this.isDifferent = !isEqual(
            this.mapEmptyValueToNull(this.formContact),
            this.mapEmptyValueToNull(this.originalContact),
          );
        }
      },
      deep: true,
    },
  },
  computed: {
    editingContactAttr() {
      return this.$store.state.contact.editingContact;
    },
  },
  methods: {
    checkObject(obj) {
      return obj && obj !== 'null' && obj !== 'undefined';
    },
    inputActive(item) {
      const el = item.target;
      document
        .querySelectorAll('.custom-field-suggestion label')
        .forEach((e) => e.classList.remove('active'));
      // el.parentElement.classList.remove('active');
      el.parentElement.classList.add('active');
      document.addEventListener('click', (e) => {
        if (e.target !== el) {
          document
            .querySelectorAll('.custom-field-suggestion label')
            .forEach((e) => e.classList.remove('active'));
        }
      });
    },
    customFieldDiff() {
      const difference = differenceBy(this.customFields, this.currentCustomFields, 'id');
      console.log('customFieldDiff: ', difference);
      this.customFieldsToBeAdded = cloneDeep(difference); // Avoid the JavaScript behavior copied-by-reference
    },
    setCompareUser(user) {
      this.originalContact = cloneDeep(user);
      this.isDifferent = false;
    },
    // Method needed because '' !=== null
    mapEmptyValueToNull(object) {
      Object.keys(object).forEach((key) => {
        if (object[key] === '') {
          object[key] = null;
        }
      });
      return object;
    },
    // helloWorld(id) {
    //   console.log('Hello World!');
    //   this.getContact(id);
    // },
    fetchCustomFields() {
      console.log('fetchCustomFields...');
      axios()
        .get('/contacts/custom-field')
        .then((response) => {
          this.customFields = [];

          const customFields = this.customFields;

          response.data?.forEach((field) => {
            if (field.id && field.name) {
              customFields.push({
                account_id: field.account_id,
                appears_omni: field.appears_omni,
                deleted: field.deleted,
                description: field.description,
                id: field.id,
                name: field.name,
                required_field: field.required_field,
                sensitive_content: field.sensitive_content,
                value: field.value !== undefined ? field.value : '',
              });
            }
          });
          // this.selectedCustomFieldId = customFields[0].name;
          console.log('CUSTOM FIELD', customFields, response);
        });
    },
    getContact(id) {
      if (id === undefined || id === null || id === '') {
        return false;
      }
      console.log('getContact: ', id);

      return ContactService.getContact(id).then(
        (response) => {
          this.formContact = response;

          this.currentCustomFields = [];
          if (this.formContact.fill_custom_fields && Array.isArray(this.formContact.fill_custom_fields)) {
            this.formContact.fill_custom_fields.forEach((field) => {
              // eslint-disable-next-line camelcase
              if (field?.custom_field) {
                this.currentCustomFields.push(field.custom_field);
              }
            });
          }

          this.setCompareUser(response);
          setTimeout(() => {
            this.customFieldDiff();
          }, 100);

          console.log('response: ', response);
          console.log('formContact: ', this.formContact);
          this.isLoading = false;

          return response; // retorna algo também aqui
        },
        (error) => {
          this.content = error;
          return false; // retorna algo no caso de erro
        },
      );
    },
    getContactChat(id) {
      if (id === undefined || id === null || id === '') {
        return false;
      }
      this.isLoading = true;
      console.log('getContact: ', id);
      return ContactService.getContact(id).then(
        (response) => {
          this.formContact = response;
          // Fill current custom fields
          Object.keys(this.formContact.fill_custom_fields).forEach((elm, i) => {
            // console.debug('TTTT Inner fields: ', this.formContact.fill_custom_fields[i].custom_field, '\nOuter field: ', this.formContact.fill_custom_fields[i].value);
            this.currentCustomFields.push(
              this.formContact.fill_custom_fields[i].custom_field,
            );
          });
          this.setCompareUser(response);
          setTimeout(() => {
            this.customFieldDiff();
          }, 100);
          console.log('response: ', response);
          console.log('formContact: ', this.formContact);
        },
        (error) => {
          this.content = error;
        },
      );
    },
    getGroupList() {
      ContactService.getGroups().then(
        (response) => {
          this.groupList = response;
        },
        (error) => {
          this.content = error;
        },
      );
    },
    momentDate(date) {
      let dateString = '';
      dateString = this.$i18n.locale === 'en' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
      return moment(date).locale(this.$i18n.locale).utc().format(dateString);
    },
    checkZipCode(cep) {
      // cep = this.zipCodeMask(cep);
      setTimeout(() => {
        if (cep.length === 9) {
          webApi.get(`https://viacep.com.br/ws/${cep}/json/`).then((response) => {
            console.log('CEP Response: ', response);
            const street = response.data.logradouro;
            const neighbourhood = response.data.bairro;
            const city = response.data.localidade;
            const uf = response.data.uf;

            this.formContact.address =
              neighbourhood !== '' && neighbourhood !== undefined ? `${street}` : '';
            this.formContact.district = neighbourhood;
            this.formContact.city = city;
            this.formContact.state = uf;
          });
        }
      }, 200);
      // console.log('CEP Teste');
    },
    checkCustomFieldId(e) {
      /* eslint-disable */
      if (e) {
        return Object.values(this.formContact.fill_custom_fields).some(
          (el) => el.custom_field_id === e
        );
      } else {
        return Object.values(this.formContact.fill_custom_fields).some(
          (el) => el.custom_field_id === this.selectedCustomFieldId
        );
      }
      /* eslint-enable */
    },
    handleEditSelectCustomField(id, value, state) {
      setTimeout(() => {
        if (this.isDifferent) {
          this.editSelectedCustomField = this.isDifferent;
          this.customFieldIdToEdit[id] = value;
        } else {
          this.editSelectedCustomField = this.isDifferent;
        }
      }, 200);
    },
    handleEditCustomField() {
      if (this.editSelectedCustomFieldValue) {
        document.getElementById('saveBtn').removeAttribute('disabled');
      } else {
        document.getElementById('saveBtn').setAttribute('disabled', 'disabled');
      }
    },
    handleShowAddCustomField() {
      this.customFieldAdd = !this.customFieldAdd;
      if (this.customFieldAdd === false) {
        this.selectedCustomFieldId = '';
        this.selectedCustomFieldName = '';
        document.getElementById('saveBtn').setAttribute('disabled', 'disabled');
      }
    },
    handleAddCustomField() {
      /* eslint-disable */
      const custom_fields = {};
      /* eslint-enable */
      const cfs = this.customFields.map((s, index) => s);
      this.formContact = { ...this.formContact, ...{ custom_fields } };
      Object.keys(cfs).forEach((item) => {
        console.log(`CFS -> \nID: ${cfs[item].id}, \nVALUE: ${cfs[item].value}`);
        Vue.set(this.formContact.custom_fields, cfs[item].id, cfs[item].value);
      });
    },
    handleSelectCustomField(e) {
      // Object.keys(customFields).find(key => customFields[key] === value);
      let result = '';
      result = this.customFields.find((item) => item.id === e);
      this.selectedCustomFieldName = result.name;
      // console.log('HandleChange: ', this.selectedCustomFieldName);
      this.existCustomField = this.checkCustomFieldId();
      document.getElementById('saveBtn').removeAttribute('disabled');
      // console.log('Custom field already exist: ', this.existCustomField);
    },
    isAddCustomField() {
      return new Promise((resolve, reject) => {
        webApi
          .post('/contacts/fill-custom-field/', {
            contact_id: this.formContact.id,
            customFields: this.customFieldsToBeAdded,
          })
          .then(
            (response) => {
              // console.log('Custom field add: ', response);
              // this.$toast.show({
              //   title: this.$t('generic-str.success'),
              //   content: this.$t('contacts-component.update'),
              //   type: 'success',
              // });
              this.customFieldAdd = false;
              // this.savingContact = false;
              console.log('isAddCustomField: ', response);
              return resolve(response);
            },
            (error) => {
              // this.$toast.show({
              //   title: `${this.$t('sms.infos.filters.status.lbl-error')} ${
              //     error.code
              //   }`,
              //   content: error.message,
              //   type: 'danger',
              // });
              // this.content = error;
              console.log('isAddCustomField: ', error);
              return reject(error);
            },
          );
      });
    },
    isCustomField() {
      // let customID = '';
      // let accID = '';
      // let contactID = '';
      return new Promise((resolve, reject) => {
        // accID = this.formContact.fill_custom_fields[0].account_id;
        // contactID = this.formContact.fill_custom_fields[0].contact_id;
        const currentCustomFields = this.formContact.fill_custom_fields;
        // customID = this.customFieldIdToEdit;
        console.log('CF to edit: ', currentCustomFields);
        webApi
          .put('/contacts/fill-custom-field/items', {
            items: this.customFieldIdToEdit,
          })
          .then(
            (response) => {
              console.log('Contatos Custom field: ', response);
              // this.$toast.show({
              //   title: this.$t('generic-str.success'),
              //   content: this.$t('contacts-component.update'),
              //   type: 'success',
              // });
              // this.savingContact = false;
              return resolve(response);
            },
            (error) => {
              console.log('Contatos Custom field error: ', error);
              // this.$toast.show({
              //   title: `${this.$t('sms.infos.filters.status.lbl-error')} ${
              //     error.code
              //   }`,
              //   content: error.message,
              //   type: 'danger',
              // });
              // this.content = error;
              return reject(error);
            },
          );
      });
    },
    isSaving() {
      return new Promise((resolve, reject) => {
        ContactService.editContact(this.formContact)
          .then((response) => {
            console.log('isSaving response: ', response);
            // resolve('Response resolve:', response);
            // this.$toast.show({
            //   title: this.$t('generic-str.success'),
            //   content: this.$t('contacts-component.update'),
            //   type: 'success',
            // });
            // this.savingContact = false;
            return resolve(response);
          })
          .catch((error) => {
            // this.$toast.show({
            //   title: `${this.$t('sms.infos.filters.status.lbl-error')} ${
            //     error.code
            //   }`,
            //   content: error.message,
            //   type: 'danger',
            // });
            // this.savingContact = false;
            console.log('isSaving error: ', error);
            return reject(error);
          });
      });
    },
    async saveContact() {
      this.editingContact = true;

      try {
        await ContactService.editContact(this.formContact);

        this.$toast.show({
          title: this.$t('generic-str.success'),
          content: this.$t('contacts-component.update'),
          type: 'success',
        });

        const promises = [];
        if (
          this.customFieldAdd &&
          !this.existCustomField &&
          this.isDifferent &&
          this.editSelectedCustomField
        ) {
          promises.push(this.isAddCustomField(), this.isCustomField(), this.isSaving());
        } else if (this.customFieldAdd && !this.existCustomField && this.isDifferent) {
          promises.push(this.isAddCustomField(), this.isSaving());
        } else if (this.editSelectedCustomField && this.isDifferent) {
          promises.push(this.isCustomField(), this.isSaving());
        } else if (
          this.editSelectedCustomField &&
          this.selectedCustomFieldId &&
          this.isDifferent
        ) {
          promises.push(this.isCustomField(), this.isAddCustomField());
        } else if (this.editSelectedCustomField && this.isDifferent) {
          promises.push(this.isCustomField());
        } else if (this.fill_custom_fields === undefined) {
          promises.push(this.isAddCustomField());
        } else if (this.isDifferent) {
          promises.push(this.isSaving());
        }

        if (promises.length > 0) {
          await Promise.all(promises);
        }

        this.editingContact = false;
        this.visible = false;
        this.savingContact = false;
        this.selectedCustomFieldId = '';
        this.selectedCustomFieldName = '';
        this.selectedCustomFieldNewValue = '';
        this.editSelectedCustomField = '';
        this.editSelectedCustomFieldValue = '';
        if (this.$route.fullPath === '/contacts') {
          this.toggleSidebar('contact-sidebar-detail');
          this.clearFilters();
        }
      } catch (error) {
        this.$toast.show({
          title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
          content: error.message,
          type: 'danger',
        });
        this.editingContact = false;
        this.savingContact = false;
      }
      if (this.$route.fullPath === '/contacts') {
        this.$store.commit('setEditingContact', false);
        this.$parent.$parent.fetch();
      }
    },
    toggleSidebar(id) {
      this.$root.$emit('bv::toggle::collapse', id);
    },
    clearFilters() {
    },
    goDetail(contact) {
      this.$router.push({ name: 'ContactDetail', params: contact });
    },
  },
};

export default contact;
